export const unteraufgabenStyles = {
    fieldsContentUnteraufgabe: {
        container:{
            p: 2,
            mb: 2,
            width: '100%'
        },
        subtasknumber:{
            color: "text.primary",
            mt: 2
        },
        headerRight:{
            display: "flex",
            justifyContent: "flex-end"
        },
        box: {
            gridTemplateColumns: ['1fr', '1fr 1fr 1fr .30fr .20fr'],
            gap: 2,
        },
        box2lang: {
            gridTemplateColumns: ['1fr', '1fr 1fr .50fr .50fr .30fr .20fr'],
            gap: 2,
        },
        antworttypField:{
            display: "grid",
            gridTemplateColumns: ['1fr']
        },
        promptField: {
            gridColumn: {
                xs: 'span 1',
                sm: 'span 5',
                md: 'span 5',
            },
            '& .MuiInputBase-root textarea': {
                resize: 'vertical',
                overflow: 'auto',
            },
        },
        prompt2langField: {
            gridColumn: {
                xs: 'span 1',
                sm: 'span 2',
                md: 'span 2',
            },
            '& .MuiInputBase-root textarea': {
                resize: 'vertical',
                overflow: 'auto',
            },
        },
        prompt2langForeignField: {
            gridColumn: {
                xs: 'span 1',
                sm: 'span 4',
                md: 'span 4',
            },
            '& .MuiInputBase-root textarea': {
                resize: 'vertical',
                overflow: 'auto',
            },
        },
        pflichtfeld: {
            marginLeft: 50
        },
        pflichtfeld2lang: {
            marginLeft: 20
        }
    },
    pageCreateUnteraufgabe: {
        paper: {
            padding: 2,
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
        }
    },
    pageUpdateUnteraufgabe: {
        paper: {
            padding: 2,
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
        },
        headerBoxWrapper: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
        }
    },
    filterTableUnteraufgaben: {
        box: {
            backgroundColor: 'white'
        }
    },
    tableUnteraufgaben: {
        box: {
            height: 600,
            width: "100%"
        },
        paper: {
            padding: 2,
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
        },
        headerBoxWrapper: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
        }
    }
}